export default {"src":"/_next/static/media/codeai-logo-inverse.a30ff4e2.svg","height":100,"width":591,"blurWidth":0,"blurHeight":0};